<template>
  <div v-html="content" class="container">
  </div>
</template>
<script>
import { api, session } from "@/assets/js/util.js";
export default {
  name: "Goods",
  inject: ["global"],
  data() {
    return {
      is_login: session.get("token") !== "",
      content: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let that = this;
      let query = { path: that.$route.path };
      api.get("article", query).then(function (res) {
        if (res.code) {
          that.content = res.data.content;
        }
      });
    },
  },
};
</script>
<style scoped>
.goods-desc li label {
  display: inline-block;
  width: 70px;
  text-align: right;
  padding-right: 3px;
}

.goods-desc li {
  line-height: 32px;
}

.product-con .price-info {
  display: inline-block !important;
  background: #f9f9fa;
  margin-left: 20px;
  padding: 0px;
  line-height: 38px;
}

.price-info span.qty {
  font-size: 20px;
  padding-left: 20px;
  padding-right: 10px;
  line-height: 38px;
  color: red;
}

.price-info span.unit {
  font-size: 16px;
  padding-right: 10px;
  line-height: 38px;
  color: red;
}

.price-info span.l {
  color: #e0e0e0;
  font-size: 16px;
  padding-right: 10px;
  line-height: 38px;
}

.price-info span.price {
  font-size: 20px;
  padding-right: 10px;
  line-height: 38px;
  color: red;
}

.price-info span.yuan {
  font-size: 16px;
  padding-right: 20px;
  line-height: 38px;
  color: red;
}

.buy-option .title {
  font-size: 16px;
  height: 32px;
  line-height: 32px;
}

.option-box li {
  display: inline-block;
  border: 1px solid #e0e0e0;
  width: 28%;
  height: 38px;
  line-height: 38px;
  margin-right: 10px;
  margin-bottom: 15px;
  padding-left: 10px;
  cursor: pointer;
  border-radius: 3px;
  text-align: center;
}

.option-box li.active {
  display: inline-block;
  border: 1px solid #ff2600;
  width: 40%;
  height: 38px;
  line-height: 38px;
  margin-right: 10px;
  margin-bottom: 15px;
  padding-left: 10px;
  cursor: pointer;
  border-radius: 3px;
}

.btn-box .sale-btn {
  display: inline-block;
  margin-right: 20px;
}

.price-box {
  width: 16%;
  display: inline-block;
  text-align: center;
}

.price-box .price,
.price-box .desc {
  font-size: 14px;
  line-height: 38px;
}

.price-wrap {
  margin-top: 20px;
}

.price-box.active {
  background: #d7e3f5;
}

.price .num {
  font-size: 20px !important;
  color: red;
  font-weight: bold;
}

.price .rmb {
  font-size: 14px !important;
  color: red;
  font-weight: bold;
  padding-right: 3px;
}

.buy-option li.active,
.buy-option li {
  border: 1px solid #ccc;
  cursor: default;
}

.buy-option li.active,
.buy-option li:hover {
  border: 1px solid #ccc;
}</style>
